import React from 'react';
import { Dialog, Tooltip, Flex, IconButton } from '@radix-ui/themes';
import { toast } from 'sonner';
import { observer } from 'mobx-react-lite';
import { CheckIcon, DeleteIcon, EditIcon, NotInterestedIcon } from 'shared/icons';

import { useNavigate } from 'react-router-dom';
import { BlogsConfirmDialog } from '../blogs-confirm-dialog';

import { useManageAlerts } from '../manage-alerts.provider';
import { CandidateAlert } from '../types';

import './alert-actions-menu.scss';

type MangerBlogMenuAction = 'DEACTIVATE' | 'ACTIVATE' | 'EMPTY' | 'DELETE';

const AlertActionsMenuView = ({ candidateAlert }: { candidateAlert: CandidateAlert }) => {
   const alertsManager = useManageAlerts();
   const navigate = useNavigate();
   const [open, setOpen] = React.useState<boolean>(false);
   const [action, setAction] = React.useState<MangerBlogMenuAction>('EMPTY');
   return (
      <Flex className="alert-actions-menu" gap="1" align="center" justify="center">
         {
            {
               0: (
                  <Tooltip content="Активувати" side="left">
                     <IconButton
                        color="red"
                        size="2"
                        className="action-trigger"
                        onClick={() => {
                           setOpen(true);
                           setAction('ACTIVATE');
                        }}
                     >
                        <NotInterestedIcon width={24} height={24} />
                     </IconButton>
                  </Tooltip>
               ),

               1: (
                  <Tooltip content="Деактивувати" side="left">
                     <IconButton
                        color="green"
                        size="2"
                        className="action-trigger"
                        onClick={() => {
                           setOpen(true);
                           setAction('DEACTIVATE');
                        }}
                     >
                        <CheckIcon width={24} height={24} />
                     </IconButton>
                  </Tooltip>
               ),
            }[candidateAlert.status]
         }

         <Tooltip content="Редагувати" side="top">
            <IconButton
               color="blue"
               size="2"
               className="action-trigger"
               highContrast
               onClick={() => {
                  navigate(`/alerts/edit/${candidateAlert.slug}`);
               }}
            >
               <EditIcon width={24} height={24} />
            </IconButton>
         </Tooltip>

         <Tooltip content="Видалити" side="top">
            <IconButton
               color="red"
               size="2"
               className="action-trigger"
               onClick={() => {
                  setOpen(true);
                  setAction('DELETE');
               }}
            >
               <DeleteIcon width={24} height={24} />
            </IconButton>
         </Tooltip>

         <Dialog.Root
            open={open}
            onOpenChange={(o) => {
               if (!o) {
                  setAction('EMPTY');
               }
               setOpen(o);
            }}
         >
            <Dialog.Content
               aria-describedby={undefined}
               onOpenAutoFocus={(e) => e.preventDefault()}
            >
               {
                  {
                     ACTIVATE: (
                        <BlogsConfirmDialog
                           title="Активувати сповіщення?"
                           message="Ви хочете активувати це сповіщення?"
                           loading={alertsManager.activateAlertState.status === 'pending'}
                           onConfirm={() => {
                              alertsManager.activateAlert({
                                 dto: { id: candidateAlert.id },
                                 onSuccess: (resp) => {
                                    setOpen(false);
                                    toast.success("Сповіщення активоване");
                                 },
                                 onError: (err) => {
                                    toast.error(err);
                                 },
                              });
                           }}
                        />
                     ),
                     DEACTIVATE: (
                        <BlogsConfirmDialog
                           title="Деактивувати сповіщення?"
                           message="Ви хочете деактивувати це сповіщення?"
                           loading={alertsManager.deactivateAlertState.status === 'pending'}
                           onConfirm={() => {
                              alertsManager.deactivateAlert({
                                 dto: { id: candidateAlert.id },
                                 onSuccess: (resp) => {
                                    setOpen(false);
                                    toast.success("Сповіщення деактивоване");
                                 },
                                 onError: (err) => {
                                    toast.error(err,);
                                 },
                              });
                           }}
                        />
                     ),
                     DELETE: (
                        <BlogsConfirmDialog
                           title="Видалити сповіщення?"
                           message="Ви хочете видалити це сповіщення?"
                           loading={alertsManager.deleteAlertState.status === 'pending'}
                           onConfirm={() => {
                              alertsManager.deleteAlert({
                                 dto: { slug: candidateAlert.slug },
                                 onSuccess: (resp) => {
                                    setOpen(false);
                                    toast.success("Сповіщення видалено");
                                 },
                                 onError: (err) => {
                                    toast.error(err);
                                 },
                              });
                           }}
                        />
                     ),
                     EMPTY: <></>,
                  }[action]
               }
            </Dialog.Content>
         </Dialog.Root>
      </Flex>
   );
};

export const AlertActionsMenu = observer(AlertActionsMenuView);
